import { render } from "./InstrumentsMenu1.vue?vue&type=template&id=10fc44bf&scoped=true"
import script from "./InstrumentsMenu1.vue?vue&type=script&lang=js"
export * from "./InstrumentsMenu1.vue?vue&type=script&lang=js"

import "./InstrumentsMenu1.vue?vue&type=style&index=0&id=10fc44bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fc44bf"]])

export default __exports__